export default __webpack_public_path__ + "static/media/ninja_logo.9ad2dfaa.png";